module.exports = __webpack_public_path__ + "static/media/milk-favicon.22196d72.ico";